import TextInput from './TextInput';

export default TextInput;



// WEBPACK FOOTER //
// ./src/ui/common/rebranding/components/TextInput/index.js